"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/MessageTemplates/TemplateBlanks.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }/* Save as template's patient details: highlights over the message, the
 * notice under it, and the Review list. */
var _react = require('react'); var _react2 = _interopRequireDefault(_react);



var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);

const markClass = (blank, on) => _classBuilder2.default.call(void 0, 
  'message-template-editor--highlight',
  on ? 'message-template-editor--highlight-on' : `message-template-editor--highlight-${_nullishCoalesce(_optionalChain([blank, 'optionalAccess', _ => _.Confidence]), () => ( 'high'))}`,
)

/* A copy of the message laid over the textarea, with transparent text and a
 * tint behind each detail, so the details show in place. */
 const BlankHighlights = _react2.default.forwardRef(
  ({ body, marks, blanks }, ref) => {
    const pieces = []
    let from = 0
    for (const mark of marks) {
      pieces.push(body.slice(from, mark.start))
      pieces.push(_react2.default.createElement('mark', { key: mark.index, className: markClass(blanks[mark.index], mark.on), __self: this, __source: {fileName: _jsxFileName, lineNumber: 22}},  body.slice(mark.start, mark.end) ))
      from = mark.end
    }
    pieces.push(body.slice(from))
    return (
      _react2.default.createElement('div', { ref: ref, className: "message-template-editor--highlights", 'aria-hidden': "true", 'data-testid': "template-blank-highlights", __self: this, __source: {fileName: _jsxFileName, lineNumber: 27}}
        ,  pieces 
         /* A trailing line break needs a character after it to take up space. */ 
        ,  body.endsWith('\n') ? ' ' : null 
      )
    )
  },
); exports.BlankHighlights = BlankHighlights
exports.BlankHighlights.displayName = 'BlankHighlights'

 const BlankNoticeLine = ({
  notice, onBlankAll, onReview, onRetry,
}) => (
  _react2.default.createElement('p', { className: _classBuilder2.default.call(void 0, 'message-template-editor--blanks', `message-template-editor--blanks-${notice.kind}`), role: "status", __self: this, __source: {fileName: _jsxFileName, lineNumber: 40}}
    , _react2.default.createElement('span', { className: "message-template-editor--blanks-icon", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 41}}, "ⓘ")
    , _react2.default.createElement('span', { className: "message-template-editor--blanks-text", __self: this, __source: {fileName: _jsxFileName, lineNumber: 42}},  notice.text )
    ,  notice.kind === 'detected' && notice.canBlankAll && (
      _react2.default.createElement('button', { type: "button", className: "message-template-editor--blanks-button", onClick: onBlankAll, __self: this, __source: {fileName: _jsxFileName, lineNumber: 44}}, "Blank all" )
    )
    ,  notice.kind === 'failed'
      ? _react2.default.createElement('button', { type: "button", className: "message-template-editor--blanks-button", onClick: onRetry, __self: this, __source: {fileName: _jsxFileName, lineNumber: 47}}, "Retry")
      : _react2.default.createElement('button', { type: "button", className: "message-template-editor--blanks-button", onClick: onReview, __self: this, __source: {fileName: _jsxFileName, lineNumber: 48}}, "Review")
    
  )
); exports.BlankNoticeLine = BlankNoticeLine

const BlankRow = ({
  blank, index, on, onToggle,
}) => {
  const toggle = _react.useCallback.call(void 0, () => onToggle(index), [onToggle, index])
  return (
    _react2.default.createElement('li', { className: "message-template-editor--blank-row", __self: this, __source: {fileName: _jsxFileName, lineNumber: 58}}
      , _react2.default.createElement('label', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 59}}
        , _react2.default.createElement('input', { type: "checkbox", checked: on, onChange: toggle, __self: this, __source: {fileName: _jsxFileName, lineNumber: 60}} )
        , _react2.default.createElement('span', { className: "message-template-editor--blank-text", __self: this, __source: {fileName: _jsxFileName, lineNumber: 61}},  blank.Text )
        , _react2.default.createElement('span', { 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 62}}, " → "  )
        , _react2.default.createElement('code', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 63}},  `{{${blank.Variable}}}` )
        ,  blank.Confidence === 'low' && _react2.default.createElement('span', { className: "message-template-editor--blank-maybe", __self: this, __source: {fileName: _jsxFileName, lineNumber: 64}}, "maybe") 
      )
    )
  )
}

/* Each detail with a checkbox: checked swaps it for its variable. */
 const BlankReviewList




 = ({ blanks, on, onToggle, onDone }) => (
  _react2.default.createElement('div', { className: "message-template-editor--blank-review", __self: this, __source: {fileName: _jsxFileName, lineNumber: 77}}
    , _react2.default.createElement('p', { className: "message-template-editor--blank-review-title", id: "message-template-blanks-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 78}}, "Checked details become variables. Uncheck any to keep, such as the clinic's address."

    )
    , _react2.default.createElement('ul', { 'aria-labelledby': "message-template-blanks-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 81}}
      ,  blanks.map((blank, i) => (
        _react2.default.createElement(BlankRow, { key: `${blank.Start}-${blank.Variable}`, blank: blank, index: i, on: !!on[i], onToggle: onToggle, __self: this, __source: {fileName: _jsxFileName, lineNumber: 83}} )
      ))
    )
    , _react2.default.createElement('button', { type: "button", className: "message-template-editor--blanks-button", onClick: onDone, __self: this, __source: {fileName: _jsxFileName, lineNumber: 86}}, "Done")
  )
); exports.BlankReviewList = BlankReviewList
